import { render, staticRenderFns } from "./Requestdemo.vue?vue&type=template&id=71190dee&"
import script from "./Requestdemo.vue?vue&type=script&setup=true&lang=js&"
export * from "./Requestdemo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports